import { InternalAxiosRequestConfig } from "axios";

export enum APITypes {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE',
};

export type APIRouteType = {
  url: string;
  method: APITypes;
  isBodyRequired: boolean;
  isQueryParamsRequired: boolean;
  isPathParamsRequired: boolean;
  isAuthHeaderRequired: boolean;
  isFileUpload: boolean;
};

export enum APIEndpoints {
  USER_SIGNIN = 'signIn',
  USER_FORGOT_PASSWORD = 'forgotPassword',
  USER_LOGOUT = 'logout',
  USER_RESET_PASSWORD = 'resetPassword',
  CASE_LIST = "caseList",
  GET_PROVIDER_SPECIALITIES = 'getProviderSpecialities',
  USER_UPDATE = 'userUpdate',
  ADD_USER = 'addUser',
  NPI_LOOKUP = 'npiLookup',
  ADD_PROVIDER = 'addProvider',
  ADD_PRACTICE = 'addPractice',
  PRACTICE_DROPDOWN = 'practiceDropdown',
  PATIENT_DROPDOWN = 'patientDropdown',
  PROVIDER_DROPDOWN = 'providerDropdown',
  ADD_ENROLLMENT = 'addEnrollment',
  GET_PROCEDURE_DROPDOWN = 'getProcedureDropdown',
  GET_DIAGNOSIS_DROPDOWN = 'getDiagnosisDropdown',
  GET_SITE_OF_CARE_DROPDOWN = 'getSiteOfCareDropdown',
  ADD_NEW_CASE = 'addNewCase',
  GET_PATIENT_DETAILS_BY_ID = 'getPatientDetailsById',
  CASE_DETAIL  = 'caseDetail',
  ADD_NOTE = "addNote",
  FETCH_DOCUMENT = 'fetchDocument',
  UPLOAD_CASE_FILE = "uploadCaseFile",
  DOWNLOAD_ZIP_FILE = 'downloadZipFile',
  CLONE_CASE_DETAILS = 'cloneCaseDetails',
  TREATMENT_LISTING = 'treatmentListing',
  ORDER_LISTING = 'orderListing',
  CREATE_ORDER = 'createOrder',
  TREATMENT_STATUS_UPDATE  = 'treatmentStatusUpdate',
  SCHEDULE_REP_VISIT = 'scheduleRepVisit',
  UPLOAD_PEF = 'uploadPEF',
  REQUEST_TREATMENT_NOT_TREATING = 'requestTreatmentNotTreating',
  DOWNLOAD_REQUEST_FORM = 'downloadRequestForm',
  MANUFACTURE_STATISTICS  = 'manufactureStatistics',
  MANUFACTURE_STATISTICS_PDF_DOWNLOAD = 'manufactureStatisticsPdfDownload',
  CASE_DETAIL_POPUP = 'caseDetailPopup',
  MANUFACTURE_STATISTICS_REPORT_DOWNLOAD  ='manufactureStatisticsReportsDownload',
  MANUFACTURE_STATISTICS_SOC_DOCTOR_DROPDOWN  ='manufactureStatisticsSocAndDoctorsDropdown',
  FETCH_PRECERT='fetchPrecert',
  FETCH_PRECERT_CASE_DETAIL='fetchPrecertCaseDetail',
  SUBMIT_PRECERT = 'submiPrecert',
  TRANSFER_RX = 'transferRX',
  GET_PRODUCTS = 'getProducts',
  GET_USER_FOR_ACCOUNT_MANAGER = 'getUserForAccountManager',
  APPEAL_CASE = 'appealCase',
  REVIEW_PRECERT_APPROVE = 'reviewPrecertApprove',
  REVIEW_PRECERT_DENY = 'reviewPrecertDeny',
  UPDATE_CASES = 'updateCases',
  RETREATMENT_LISTING = 'retreatmentListing',
  DELETE_RETREATMENT = 'deleteRetreatment',
  // GET_RETREATMENT_REQUESTS_COUNT = 'getRetreatmentRequestCount',
  LOCAL_COVERAGE = 'localCoverage',
  PRIOR_AUTHORIZATION = 'priorAuthorization',
  DOWNLOAD_LOCAL_REQUEST_FORM ='downloadLocalRequestForm',
  GET_PRECERT_REVIEW_FILE = 'getPrecertReviewFile',
  UPDATE_PRECERT='updatePrecert',
  UPDATE_PRIOR_AUTH = 'updatePriorAuth',
  GET_PRIOR_AUTH_REVIEW_FILE='getPriorAuthReviewFile',
  DEMO_RESET_CASES = 'demoResetCases',
  RESOURCE_ANALYTICS = 'resourcesAnalytics',
  EOBs_DETAIL  = 'eobsDetail',
  EOBs_LISTING = 'eobsListing',
  EOBs_Upload = 'eobsUpload',
  FETCH_EOB_FILE = 'fetchEOBsFile',
  FETCH_CASE_SUMMARY = 'fetchCaseSummary',
  FETCH_EOBs_REPORTS = 'fetchEOBs',
  PATIENT_STATISTICS  = 'patientStatistics',
  TODO_ACTION_DASHBOARD_STATISTICS='todoActionDashboardStatistic',
  SAVE_NOTE='saveNote',
  TRANSFER_CASE = 'transferCase',
  USER_LIST_STATISTICS='userListStatistics',
  GET_GLOBAL_PATIENT_DETAIL_BY_ID = 'getGlobalPatientDetailsById',
  UPDATE_GLOBAL_PATIENT_DETAIL_BY_ID = 'updateGlobalPatientDetailsById',
  // MANUFACTURE_STATISTICS_REPORT_DOWNLOAD = 'manufactureStatisticsReportDownload',
  GET_MANUFACTURER_CASE_LISTING = 'getManufacturerCaseListing',
  COPAY_CLAIM = 'copayClaim',
  EVENT_ANALYTICS = 'eventAnalytics',
  GET_EVENT_ANALYTICS = 'getEventAnalytics',
  GET_MANUFACTURER_FILTER_DOCTOR = 'getManufacturerFilterDoctor',
  GET_MANUFACTURER_FILTER_PRACTICE = 'getManufacturerFilterPractice',
  FETCH_INSURANCE = 'fetchInsurance',
  TERRITORY_DROPDOWN= 'territory_dropdown',
  REGION_DROPDOWN= 'region_dropdown',
  COMPLETED_CLAIMS = 'completed_claims',
  ALL_CLAIMS = 'all_claims',
  STATE_DROPDOWN= 'state_dropdown',
  CAS_DROPDOWN= 'cas_dropdown',
  AD_PRACTICE_DROPDOWN = 'ADPracticeDropdown',
  AD_PROVIDER_DROPDOWN = 'ADProviderDropdown',
  TODO_ACTION_DASHBOARD_STATISTICS_FILE_DOWNLOAD = 'todoActionDashboardStatisticsFileDownload',
  GET_RETREATMENT_REQUESTS_COUNT = 'getRetreatmentRequestCount',
  HANDLE_BAA = 'handleBAA',
  SAVE_CASE_DRAFT = 'saveCaseDraft',
  UPDATE_CASE_DRAFT = 'updateCaseDraft',
  GET_CASE_DRAFTS = 'getCaseDrafts',
  DELETE_CASE_DRAFT = 'deleteCaseDraft',
  LOOKUP_PAITENT_WITH_NAME = 'lookupPatientWithName',
  UPDATE_SIGNATURE = 'updateSignature',
  DOCTORS_SIGNATURE_LISTING = 'doctorsSignatureList',
  CHECK_SIGNATURE = 'checkSignature',
  UPDATE_FROM_THIRD_PARTY = 'updateFromThirdParty',
  INSURANCE_DROPDOWN = 'InsuranceDropdown',
};

export type AuthAPIsType = {
  [key in APIEndpoints]: APIRouteType;
};

export type FetchHookType<TPathParams, TQueryParams, TResponseData> =
  (apiType: APIEndpoints, pathParams?: TPathParams, queryParams?: TQueryParams) =>
    { loading: boolean, error: string | null, data: TResponseData, mutate: <TBodyType>(body: TBodyType) => void };

export type UpdatedAxiosInstance<T> = InternalAxiosRequestConfig<T> & {
  pathParams: object;
};
